/* Visible-by-default, one-time editorial motion. No scroll handlers, timers,
   perpetual animation frames or dependencies; hero and workbench are excluded. */
(function () {
  'use strict';
  if (window.__tmEditorialMotionV46) return;
  window.__tmEditorialMotionV46 = true;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var desktop = window.matchMedia('(min-width: 1000px) and (hover: hover) and (pointer: fine)');
  var observer, seen = new WeakSet();
  var running = new Set();
  function play(element, frames, options) {
    if (!element.animate || reduced.matches || document.visibilityState === 'hidden') return;
    var animation = element.animate(frames, options);
    running.add(animation);
    animation.finished.then(function () { running.delete(animation); }, function () { running.delete(animation); });
  }
  function enter(element) {
    if (seen.has(element) || reduced.matches) return;
    seen.add(element);
    var wide = desktop.matches;
    if (element.matches('.tm46-media,.tmg46-media')) {
      if (wide) {
        element.classList.add('tm46-motion-media');
        element.addEventListener('animationend', function done(event) {
          if (event.target !== element || event.animationName !== 'tm46-unfold') return;
          element.classList.remove('tm46-motion-media');
          element.removeEventListener('animationend', done);
        });
      }
      var image = element.querySelector('img');
      if (image) play(image, wide ? [{transform:'scale(1.055)',opacity:.85},{transform:'scale(1)',opacity:1}] : [{opacity:.85},{opacity:1}], {duration:wide ? 1000 : 380,easing:'cubic-bezier(.2,.7,.2,1)'});
    } else {
      // Card frames stay perfectly aligned even during their entrance.
      var card = element.matches('.tm46-paper,.tm46-gallery-card,.tm46-guide-card');
      var frames = card ? [{opacity:.72},{opacity:1}] : [{opacity:wide ? .65 : .85,transform:'translateY('+(wide ? 12 : 6)+'px)'},{opacity:1,transform:'translateY(0)'}];
      play(element,frames,{duration:wide ? 620 : 320,easing:'cubic-bezier(.2,.7,.2,1)'});
    }
  }
  function enhance(scope) {
    if (reduced.matches || !('IntersectionObserver' in window)) return;
    if (!observer) observer=new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);enter(entry.target);
      });
    },{threshold:.08,rootMargin:'0px 0px -18px 0px'});
    scope.querySelectorAll('.tm46 [data-tm46-reveal],.tm46 .tm46-media,.tmg46 [data-tm46-reveal],.tmg46 .tmg46-media').forEach(function (element) {
      if (!seen.has(element)) observer.observe(element);
    });
  }
  function stop() {
    if (observer) {observer.disconnect();observer=null;}
    running.forEach(function (animation) {animation.cancel();});running.clear();
    document.querySelectorAll('.tm46-motion-media').forEach(function (element) {element.classList.remove('tm46-motion-media');});
  }
  function motionChange() {stop();if (!reduced.matches) enhance(document);}
  if (reduced.addEventListener) reduced.addEventListener('change',motionChange);
  if (desktop.addEventListener) desktop.addEventListener('change',motionChange);
  if (document.readyState==='loading') document.addEventListener('DOMContentLoaded',function () {enhance(document);},{once:true});
  else enhance(document);
  document.addEventListener('shopify:section:load',function (event) {enhance(event.target);});
  document.addEventListener('shopify:section:unload',stop);
  document.addEventListener('visibilitychange',function () {if (document.visibilityState==='hidden') stop();else enhance(document);});
  window.addEventListener('pagehide',stop);
  window.addEventListener('pageshow',function (event) {if (event.persisted) enhance(document);});
}());
